



















// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import DiecutEditComp from "@/components/DiecutEditComp.vue";
@Component({
  components: {
    DiecutEditComp,
    Dialog,
    ErrorList
  }
})
export default class DiecutEdit extends HacoCommon {
  // put something
}
